import { LabelWrapper } from '@gameday/react-components/components'

import QuestionForm from '../../../../factories/QuestionForm'
import NavigationButtons from '../../Common/NavigationButton'

const BasicInfoComponent = ({
  questions,
  formData,
  buttonColour,
  buttonTextColour,
  next,
  previous,
  onSubmit = () => {},
  defaultValue,
  memberTypes,
  disableMemberType,
  onBack = () => {},
  disableQuestions,
  defaultCountry,
  showValidationError,
  preventDefaultOnBack,
  onChange = () => {},
  formType,
}) => {
  let submit = () => {}
  return (
    <div>
      <h2>Let’s add your basic details</h2>
      <h3>Basic Information</h3>
      <hr />
      <QuestionForm
        questions={questions}
        formData={formData}
        bindHandler={({ submitForm }) => {
          submit = submitForm
        }}
        onSubmit={values => {
          onSubmit(values)
          next()
        }}
        defaultValue={defaultValue}
        memberTypes={memberTypes}
        disableMemberType={disableMemberType}
        disableQuestions={disableQuestions}
        defaultCountry={defaultCountry}
        onChange={onChange}
        formType={formType}
      />
      {showValidationError && (
        <>
          <hr />
          <LabelWrapper
            errorText={
              showValidationError === 'form_age'
                ? "This form isn't currently taking registrations for a person of this age."
                : 'Sorry you do not meet the criteria for this event. '
            }
          />
        </>
      )}
      <NavigationButtons
        buttonColour={buttonColour}
        buttonTextColour={buttonTextColour}
        isContinueDisabled={showValidationError}
        preventDefaultOnBack={preventDefaultOnBack}
        onSubmit={() => {
          submit()
        }}
        onBack={() => {
          previous()
          onBack()
        }}
      />
    </div>
  )
}

export default BasicInfoComponent
